




















































































































import Debug from "@/components/utility/Debug.vue";
import LayoutReport from "@/layouts/LayoutReport.vue";
import TheLayoutBase from "@/layouts/TheLayoutBase.vue";
import { convertPdfToImg } from "@/lib/utility/convertPdfToImage";
import { formatHoursAndMinutes, simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { downloadUrlFromRemoteOrigin } from "@/lib/utility/downloadFileFunc";
import { handleError } from "@/lib/utility/handleError";
import { SignCreateModule } from "@/store/modules/sign-create.store";
import { Component, Vue, Watch } from "vue-property-decorator";
import SignFormEditor from "./SignFormEditor.vue";
const VueTyper = require("vue-typer").VueTyper;

@Component({
  components: {
    TheLayoutBase,
    LayoutReport,
    Debug,
    SignFormEditor,
    VueTyper
  },
  filters: {
    simpleDoubleDigitDate,
    formatHoursAndMinutes
  }
})
export default class SignFormSigned extends Vue {
  page = 0;
  pages: string[] = [];

  loading = false;

  clientHeight = 0;

  loadingDownload = false;

  interval: any = {};
  value = 35;

  snackbar = true;
  timeout = 5000;

  @Watch("signed")
  async convert() {
    if (!this.signed) return;

    if (this.signed.status === "signed") {
      clearInterval(this.interval);

      this.loading = true;
      const images = await convertPdfToImg(this.signed.documents[0]);
      if (images) {
        this.pages = images;
      }
      this.loading = false;
    }
  }

  async mounted() {
    // Sets a timeout for 35 seconds. The `findSignedRequest` route is throttled for 2 requests per minute
    this.interval = setInterval(() => {
      if (this.value <= 0) {
        this.$emit("refresh");

        return (this.value = 35);
      }
      const increment = 1;
      this.value -= increment;
    }, 1000);

    if (this.signed && this.signed.status === "signed") {
      await this.convert();
    }
  }

  get workText() {
    return [
      "oh yes, wait a minute",
      "Wait",
      "wait, Mr. Postman",
      "if there's a letter in your bag for me",
      "Please, please",
      "why's it takin' such a long time",
      "for me to hear from that boy of mine?",
      "Please, Mr. Postman, look and see",
      "If there's a letter, a letter for me",
      "Please, please, Mr. Postman",
      "why's it takin' such a long time?",
      "Why don't you check it and see one more time for me?",
      "You gotta wait a minute, wait a minute",
      "Wait a minute, wait a minute",
      "Ooh, Mr. Postman",
      "C'mon, deliver the letter, the sooner, the better, ah",
      "Mr. Postman",
      "Ah-ah",
      "Ooh-ooh-ooh",
      "Ah-ah-ah",
      "Ooh-ooh-ooh",
      "Ah-ah-ah"
    ];
  }

  get signed() {
    return SignCreateModule.signed;
  }

  beforeDestroy() {
    clearInterval(this.interval);
  }

  get signedSubtitle() {
    if (!this.signed) return undefined;

    const created = new Date(this.signed.timestamp.created);

    return this.$t("sign.Sign.signedSubtitle", {
      title: this.signed.title,
      date: simpleDoubleDigitDate(this.signed.timestamp.created),
      hours: created.getHours(),
      minutes: created.getMinutes(),
      firstName: this.signed.firstName,
      lastName: this.signed.lastName,
      action: this.$t(`sign.Sign.signedAction.${this.signed.status}`)
    });
  }

  goPreviousPage() {
    if (this.page === 0) {
      this.page = this.pages.length;
    }

    this.page--;
  }

  goNextPage() {
    this.page = (this.page + 1) % this.pages.length;
  }

  onResize() {
    this.clientHeight = document.documentElement.clientHeight;
  }

  async download() {
    if (!this.signed) return;

    this.loadingDownload = true;
    await downloadUrlFromRemoteOrigin(this.signed.documents[0], `${this.signed.title}.pdf`).catch(handleError);
    this.loadingDownload = false;
  }
}
